import React, { Component } from 'react'
import { WebSocketEventEmitter } from "./WebSocketEventEmitter.js";
const WebSocket = require('isomorphic-ws');
let wsSocket;
let timerId;
const websocket_check = 60000; //checks every 1 minutes


export default class WebSocketReceiver extends Component {
    componentDidMount = () => {
        this.initiateWebSocket();
        this.configureWebsocket();
    }

    initiateWebSocket() {
        clearInterval(timerId)

        wsSocket = new WebSocket(window.config.getWebsocketUrl());

        wsSocket.onopen = () => {
            console.debug('WebSocket Client Connected!');
            if (this.props.currentUser) {
                this.dispatchInitialMessage();
            }
        };

        wsSocket.onclose = () => {
            console.debug('disconnected');
            timerId = setInterval(() => this.initiateWebSocket(), websocket_check)
        };

        wsSocket.onerror = (err) => {
            console.debug('Websocket Error', err);
            wsSocket.close();
        };

        //receiving a notification from server
        wsSocket.onmessage = (msg) => {
            let dataFromServer = JSON.parse(msg.data)
            // console.log("INFOR SENT FROM HERE")
            // console.log(dataFromServer)
            //filename isn't always included so it is left out intentionally from destructuring.
            const fileName = dataFromServer.filename;
            console.log('currentUser', this.props.currentUser._id)
            if (this.props.currentUser) {
                this.refreshUserNotifications(this.props.currentUser._id, dataFromServer.sender);
            }
            this.emitWebsocket(dataFromServer, fileName)
        };
    }



    configureWebsocket() {
        WebSocketEventEmitter.on('WSInitiator', () => {
            if (wsSocket.readyState === 1) {
                this.dispatchInitialMessage();
            }
        });

        WebSocketEventEmitter.on('WSListener', (msg) => {
            if (wsSocket.readyState === 1) {
                wsSocket.send(JSON.stringify(msg));
            }
        });

        // WebSocketEventEmitter.on('WebsocketReceiver', (notification) => {
        //     let allUsers = Object.values(this.props.users);
        //     let displayingModelUploader = this.props.match.url.split("/dashboard/").pop() === "Model Uploader"
        //     for (let user of allUsers) {
        //         if ((user.role === "Engineer" || user.role === "Dev") && !displayingModelUploader) {
        //             const payload = { user_id: user._id, notification: notification.notification }
        //             this.props.addNewNotification(payload)
        //         }
        //     };
        // })

        WebSocketEventEmitter.on('WebsocketReceiverFeedback', (eventData) => {
            // let feedback = {
            //     comment: eventData.message.split(": ")[2],
            //     username: eventData.sender,
            //     wip_name: eventData.message.split(":")[0],
            //     wip_id: eventData.message.split(": ")[1]
            // }
            this.props.refreshFeedbacks()
        })
    }

    dispatchInitialMessage() {
        let propsList;

        if (this.props.match.url.includes('dashboard'))
            propsList = this.props.match.url.split("/dashboard/")
        else
            propsList = this.props.match.url.split("/login/")
        let sender = propsList.pop()
        if (sender === '/') {
            sender = '/login'
        }
        
        const msg = {
            eventSource: 'identify_user',
            sender,
            currentUserId: this.props.currentUser._id,
            currentUserRole: this.props.currentUser.role
        }

        WebSocketEventEmitter.emit('WSListener', msg);
    }
  
    refreshUserNotifications(userId, sender) {
        let user = this.props.currentUser
        if (user.username !== sender) {
            //only refreshes for if the user is expected to have received notification
            if ((user.role === "Work Lead" || user.role === "Dev")) {
                this.props.refreshUserNotifications(userId)
            }
        }
    }

    emitWebsocket = (dataFromServer, fileName ) => {
        const {module, sender, message, process} = dataFromServer
        if (module === "bwi") {
            WebSocketEventEmitter.emit('BWI', dataFromServer);
        }
        if (process === "Started" || process === "Progression" || process === "Completed") {
            WebSocketEventEmitter.emit('ProgressTracker', dataFromServer);
        }

        if (process === 'New Feedback') {
            WebSocketEventEmitter.emit('WebsocketReceiverFeedback', { message, sender });
        }

        if (process && fileName) {
            // console.log("emitting Model Uploader Progress")
            WebSocketEventEmitter.emit('ModelUploaderProgress', { message, sender, fileName, process});
        }
    }

    render() {
        return <div style={{ display: "none" }}>WebSocketReceiver</div>
    }
}